import React, { Suspense } from 'react';
import styled from 'styled-components';
import Header from './Header';
import Footer from './Footer';

// Loading fallback component
const LoadingFallback = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.textSecondary};
  padding: 2rem;
`;

const SimpleLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: ${({ theme }) => theme.colors?.bgPrimary || '#ffffff'};
`;

const MainContainer = styled.main`
  flex: 1;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  margin-top: 64px; // Account for fixed header
  
  @media (max-width: 768px) {
    margin-top: 56px;
    padding: 1.5rem 1rem;
  }
`;

const SimpleLayout = ({ 
  children, 
  user, 
  onLoginClick, 
  onLogout 
}) => {
  return (
    <SimpleLayoutWrapper>
      <Header 
        user={user}
        onLoginClick={onLoginClick}
        onLogout={onLogout}
        showSidebarToggle={false}
      />
      <MainContainer>
        <Suspense fallback={<LoadingFallback>Loading page...</LoadingFallback>}>
          {children}
        </Suspense>
      </MainContainer>
      <Footer />
    </SimpleLayoutWrapper>
  );
};

export default SimpleLayout;